import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: 26,
    fontWeight: 700,
    width: "100%",
    textAlign: "left",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

interface IHeadingTextProps {}

export const HeadingText: FunctionComponent<IHeadingTextProps> = (props) => {
  const { children } = props;
  const classes = useStyles();
  return (
    <Typography className={classes.heading} align="center">
      {children}
    </Typography>
  );
};
